import React from "react";

import "./Header.css";

export default function Header(props) {
  return (
    <div
      style={{
        width: "100%",
      }}
      className="text headersymbol"
    >
      <div
      className="large"
        style={{
          flex: 1,
          marginLeft: 20,
          textTransform: "uppercase",
          fontWeight: "600",
          display:"flex",
          justifyContent:"center",alignItems:"center"
        }}
      >
       {props.profile == null ? "NoUsername" : props.profile.username} ({props.profile == null ? "NoName" : props.profile.name})
      </div>
    </div>
  );
}
